<form [formGroup]="form" (ngSubmit)="submit()" class="space-y-2">

  <app-metro-form-input
    formControlName="deliveryCode"
    [placeholder]="'::DeliveryCode' | abpLocalization">
  </app-metro-form-input>

  @if (form.get('deliveryCode')?.touched && form.get('deliveryCode')?.errors) {
    <div class="text-sm text-red-600">
      @if (form.get('deliveryCode')?.errors?.['required']) {
        {{ '::DeliveryCodeRequired' | abpLocalization }}
      }

      @if (form.get('deliveryCode')?.errors?.['invalidCode']) {
        {{ '::Order:InvalidDeliveryCode' | abpLocalization }}
      }
    </div>
  }

</form>
